define('controllers/reportcards/reportcards.ctrl',['app'], function(app) {
    app.controller('ReportCardsController', ['$state', '$sce', '$scope', 'serviceresource', function($state, $sce, $scope, servicecard) {
        $scope.clickCard = function(card, event) {
            servicecard.cards.click(card, event);
        }

        $scope.getReportCards = function() {
            var dirId = $state.params.dirId;
            return servicecard.cards.getReportCards(dirId);
        }
    }]);
});

